import LoginForm from './components/LoginForm';
import { useTheme } from '@/helpers/theme';

const Page = () => {
  useTheme();

  return (
    <div className="flex items-center justify-center p-4 h-screen w-screen bg-topography bg-login-bg bg-blend-overlay">
      <LoginForm />
    </div>
  );
};

export default Page;
